import React, { useState } from 'react';
import { grey } from '@mui/material/colors';
import { Add, Remove } from '@mui/icons-material';
import { CircularProgress, IconButton, Stack, Typography } from '@mui/material';

import { Template } from '../../api';
import { Department } from '../../types';
import { createColumns } from './createColumns';
import { capitalizeFirstLetter } from '../../../../formatters';
import { TableView } from '../../../proposals/ui/tables/TableView';

export interface ListSectionActions {
  onSetActiveStatus: (templateId: string) => Promise<void>;
  onEditTemplate: (templateId: string) => Promise<void>;
  onRedirectToCloseReasons: (templateId: string) => void;
}

interface Props {
  renderIndex: number;
  templates: Template[];
  department: Department;
  actions: ListSectionActions;
  isActiveStatusSetting: boolean;
}

export const ListSection = ({ department, templates, actions, renderIndex, isActiveStatusSetting }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(renderIndex <= 1);

  const columns = createColumns(actions, isActiveStatusSetting);

  return (
    <Stack gap="1rem">
      <Stack
        sx={{
          borderRadius: '0.25rem',
          padding: '0.25rem 0.5rem',
          backgroundColor: grey[200],
        }}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" alignItems="center">
          <IconButton
            size="small"
            onClick={() => {
              setIsCollapsed(prev => !prev);
            }}
          >
            {!isCollapsed ? <Add /> : <Remove />}
          </IconButton>

          <Typography variant="subtitle1" component="span" fontWeight="bold">
            {capitalizeFirstLetter(department.name)}
          </Typography>

          {isActiveStatusSetting && <CircularProgress size={20} />}
        </Stack>
      </Stack>

      {isCollapsed && <TableView<Template> tableData={templates} withPagination={false} columns={columns} />}
    </Stack>
  );
};
